import { useSelector } from "react-redux";
import jobSelectors from "store/selectors/job";
import { getJobStats } from "./helpers";
import type { JobStats } from "./types";

export type CompanyJobStatsHook = JobStats;

export default function useCompanyJobStats(): CompanyJobStatsHook {
  const jobs = useSelector(jobSelectors.getEntitiesAsArray);

  return getJobStats(jobs);
}
